import { cortexApi } from '../apis'
import { type ActiveSubscription } from '@/types'

/**
 * Subscription service
 */
export const subscriptionService = {
  /**
   * Gets the active subscription for the user
   * @returns The active subscription for the user
   */
  async fetchActiveSubscription(): Promise<ActiveSubscription> {
    const response = await cortexApi.get<ActiveSubscription>(
      '/users/me/subscriptions/active'
    )

    return response.data
  },

  /**
   * Cancels the active subscription for the user
   * @returns The canceled subscription.
   */
  async cancelActiveSubscription(): Promise<void> {
    const response = await cortexApi.patch('/users/me/subscriptions/active')
    return response.data
  },
}
